import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ContractService } from '../../../services/contract.service';
import { ContractStep2Controller } from './contract-step2.controller';
import { CheckBrowserPluginsService } from '../../../services/check-browser-plugins.service';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.contract-step2', {
            url: '/contract-step2',
            ncyBreadcrumb: {
                label: 'Firma Contratto',
                parent: 'registration.contract-step1'
            },
            data: {
                authorisationLevel: 0,
                pageTitle: 'Firma il Contratto'
            },
            resolve: {
                pdfPath: (ContractService: ContractService, $q, store: ng.a0.storage.IStoreService) => {
                    return ContractService.getContractPDFPath(store.get('registeringUser'))
                        .then((result) => {
                            return result;
                        }, (error) => {
                            return $q.reject(error);
                        });
                },
                contractPdfPreviewType: ['CheckBrowserPluginsService', (CheckBrowserPlugins: CheckBrowserPluginsService) => {
                    return CheckBrowserPlugins.hasPDFReaderInstalled() ? 'pdf' : 'img';
                }],
                contractPDF: (ContractService: ContractService, pdfPath, $q, $sce, contractPdfPreviewType) => {
                    return ContractService.getContractPDF(pdfPath, contractPdfPreviewType)
                        .then((result: any) => {
                            return result.data;
                        }, (error) => {
                            return $q.reject(error);
                        });
                }
            },
            'views': {
                'multiContentRegistration': {
                    controller: ContractStep2Controller,
                    template: `
                        <section id="contract-step2" flex="100">
                            <div class="row margin-bottom-30">
                                <div class="col-xs-12">
                                    <h3>
                                        <span class="archismall-grey-header">Firma il Contratto Archi
                                            <span class="bold">SMALL</span>
                                        </span>
                                    </h3>
                                </div>
                            </div>
                            <div class="row">
                                <div class="panel panel-default" id="print-pdf-content">

                                    <div class="panel-body" ng-class="{'image': !isPDF}">
                                        <img ng-if="!isPDF" ng-src="data:image/png;base64,{{pdfContent}}">
                                        <pdf-viewer ng-if="isPDF" src='pdfContent'></pdf-viewer>
                                        <!--<object ng-if="isPDF" ng-attr-data="data:application/pdf;base64,{{pdfContent}}" type="application/pdf" class="scrollbar" name="Contratto"></object>-->

                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-4 text-left">
                                    <a class="action" ng-click="prev()">
                                        <i class="fa fa-arrow-left"></i> Indietro </a>
                                </div>
                                <div class="col-xs-4 centered">
                                    <button class="btn orange-btn col-xs-12" ng-click="openSignContractModal()">FIRMA il Contratto ArchiSMALL</button>
                                </div>
                                <div class="col-xs-2">
                                    <button ng-print print-element-id="print-pdf-content" ng-if="!isPDF">
                                        <i class="fa fa-print fa-2x"></i>
                                    </button>
                                </div>
                            </div>
                        </section>
                    `
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ContractStep2Module: string = ng
    .module('contract-step2', [
        'ui.bootstrap',
        uiRouter
    ])
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/sections/registration/contract-step2/contract-step2.module.ts